// src/components/termOfPayments/FormAddEditTermOfPayments.jsx

import React, { useEffect, useState } from "react";
import { Box, Paper, Grid, Stack, Button, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import useCreateTermOfPayment from "../../hooks/termOfPayments/useCreateTermOfPayment";
import useUpdateTermOfPayment from "../../hooks/termOfPayments/useUpdateTermOfPayment";
// import useGetTermOfPaymentsEnumValues from "../../hooks/termOfPayments/useGetTermOfPaymentsEnumValues";
import FormInput from "../inputs/FormInput";
import i18next from "i18next";
import LanguageToggle from "../global/LanguageToggle";

const FormAddEditTermOfPayments = ({ currentData, isEdit = false, onSubmitSuccess }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";
    const initialLang = localStorage.getItem("i18nextLng") || i18next.language || "ar";

    const [activeLang, setActiveLang] = useState(initialLang.startsWith("ar") ? "ar" : "en");

    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    const [nameAr, setNameAr] = useState(currentData?.name_ar || "");
    const [nameEn, setNameEn] = useState(currentData?.name_en || "");
    const [code, setCode] = useState(currentData?.code || "");
    const [status, setStatus] = useState(currentData?.status || "active");

    const { createTermOfPayments, isPending: isCreating } = useCreateTermOfPayment();
    const { updateTermOfPayments, isPending: isUpdate } = useUpdateTermOfPayment();
    // const { enumValues, isLoading: isLoadingEnum } = useGetTermOfPaymentsEnumValues();

    const loadingSubmit = isCreating || isUpdate;

    useEffect(() => {
        if (isEdit && currentData) {
            setNameAr(currentData?.name?.ar || "");
            setNameEn(currentData?.name?.en || "");
            setCode(currentData?.code || "");
            setStatus(currentData?.status || "active");
        }
    }, [isEdit, currentData]);

    const SubmitForm = (e) => {
        e.preventDefault();
        const payload = {
            name: {
                ar: nameAr || nameEn,
                en: nameEn || nameAr,
            },
            code,
            status,
        };
        if (isEdit && currentData?.id) {
            updateTermOfPayments(
                { id: currentData.id, req: payload },
                {
                    onSuccess: () => {
                        if (onSubmitSuccess) onSubmitSuccess();
                    },
                }
            );
        } else {
            createTermOfPayments(payload, {
                onSuccess: () => {
                    if (onSubmitSuccess) onSubmitSuccess();
                },
            });
        }
    };

    // Status options for FormInput select
    const statusOptions = [
        { id: "active", name: isArabic ? "نشط" : "Active" },
        { id: "disabled", name: isArabic ? "معطل" : "Disabled" },
    ];

    // Enum values options for FormInput select
    // const enumOptions = enumValues.map((item) => ({
    //     id: item.value,
    //     name: item.label,
    // }));

    return (
        <Paper
            sx={{
                p: 3,
                mt: 2,
                direction: isArabic ? "rtl" : "ltr",
                backgroundColor: isDark ? "transparent" : "#FFFFFF",
            }}
        >
            <Box
                component="form"
                onSubmit={SubmitForm}
                sx={{
                    "& .MuiTextField-root": { m: 1, width: "100%" },
                    "& .MuiFormControl-root": { m: 1, width: "100%" },
                }}
                noValidate
                autoComplete="off"
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LanguageToggle
                        activeLang={activeLang}
                        onChange={(lng) => setActiveLang(lng)}
                        showLabel={true}
                    />
                    </Grid>

                    {/* Code Field */}
                    {/* <Grid item xs={12} md={6}>
                        <FormInput
                            label={isArabic ? "الكود" : "Code"}
                            type="select"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            options={enumOptions}
                            required
                            disabled={isLoadingEnum}
                        />
                    </Grid> */}

                    {/* Status Field */}
                    <Grid item xs={12} md={6}>
                        <FormInput
                            label={isArabic ? "الحالة" : "Status"}
                            type="select"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            options={statusOptions}
                            required
                        />
                    </Grid>

                    {/* Name AR Field */}
                    {showArabic && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label={isArabic ? "الاسم بالعربية" : "Name in Arabic"}
                                type="text"
                                value={nameAr}
                                onChange={(e) => setNameAr(e.target.value)}
                                required
                            />
                        </Grid>
                    )}

                    {/* Name EN Field */}
                    {showEnglish && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label={isArabic ? "الاسم بالإنجليزية" : "Name in English"}
                                type="text"
                                value={nameEn}
                                onChange={(e) => setNameEn(e.target.value)}
                                required
                            />
                        </Grid>
                    )}

                    {/* Submit Button */}
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={loadingSubmit}
                                sx={{ minWidth: 120 }}
                            >
                                {loadingSubmit
                                    ? (isArabic ? "جاري الحفظ..." : "Saving...")
                                    : isEdit
                                    ? (isArabic ? "تحديث" : "Update")
                                    : (isArabic ? "إنشاء" : "Create")}
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default FormAddEditTermOfPayments;